import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class OperationTypeServices {
  async getByAll(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/operation-type/`, {
        headers: { 'authentication-token': getJWT()! },
        params: {
          limit: 999,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const operationTypeServices = new OperationTypeServices()
